<template lang="pug">
#graficoPrevisaoChuvaTemperatura(v-loading='isLoading')
    apex-charts.component.apexcharts-canvas(
        type='line',
        height='300',
        :options='options',
        :series='series',
        ref='chart'
    )
</template>

<script>
import { GRAFICO_PREVISAO_CHUVA_TEMPERATURA } from '../../../utils/layouts/graficos';
import ApexCharts from 'vue-apexcharts';

import MonitoramentoService from '@/services/MonitoramentoService';

export default {
    name: 'GraficoPrevisaoChuvaTemperatura',

    components: {
        ApexCharts
    },

    data() {
        return {
            dadosClimaticos: null,
            isLoading: false,
            series: [],
            options: {}
        };
    },

    mounted() {
        this.isLoading = true;
        MonitoramentoService.monitoramentoClimatico(
            this.$route.params.idAreaMonitorada
        )
            .then(({ data }) => {
                this.dadosClimaticos = data.dados;
                this.configure();
            })
            .catch(() => {
                this.$notify.error({
                    message: 'Ocorreu um erro ao buscar os dados climáticos'
                });
            })
            .finally(() => {
                this.isLoading = false;
            });
    },

    methods: {
        configure() {
            const dadosPrecipitacao = this.dadosClimaticos.find(
                d => d.tipo === 'PRECIPITACAO'
            ).dados;
            const dadosTemperaturaMaxima = this.dadosClimaticos.find(
                d => d.tipo === 'TEMPERATURA_MAXIMA'
            ).dados;
            const dadosTemperaturaMinima = this.dadosClimaticos.find(
                d => d.tipo === 'TEMPERATURA_MINIMA'
            ).dados;

            this.options = Object.assign(
                {},
                GRAFICO_PREVISAO_CHUVA_TEMPERATURA
            );

            this.options.xaxis.categories = [];
            this.options.xaxis.categories.push(
                ...dadosPrecipitacao.map(d =>
                    new Date(d.data).toLocaleDateString('pt-BR')
                )
            );

            this.series = [
                {
                    name: 'Precipitação',
                    type: 'column',
                    data: dadosPrecipitacao.map(d => d.valor)
                },
                {
                    name: 'Temperatura máxima',
                    type: 'line',
                    data: dadosTemperaturaMaxima.map(d => d.valor)
                },
                {
                    name: 'Temperatura mínima',
                    type: 'line',
                    data: dadosTemperaturaMinima.map(d => d.valor)
                }
            ];

            const max =
                this.series[1].data.reduce((a, b) => Math.max(a, b)) + 10;
            const min = 0;

            /* Deixando escala dos gráficos de temperatura iguais */
            this.options.yaxis[1].max = max;
            this.options.yaxis[1].min = min;

            this.options.yaxis[2].max = max;
            this.options.yaxis[2].min = min;

            this.$refs.chart.updateOptions(this.options);
        }
    }
};
</script>
